import { gql } from '@apollo/client';

export const GetMyObjectsQueryName = 'GetMyObjects';

export const GET_MY_OBJECTS_QUERY = gql`
  query ${GetMyObjectsQueryName} {
    getMyObjects {
      id
      createdAt
      updatedAt
      createdBy
      createdByName
      createdByEmail
      name
      description
      position
      geometry
      type
      siteId
      siteStatus
      groupId
      parentId
      parentName
      mapsVisible
      filled
      visibility
    }
  }
`;
